import React from 'react'
import moment from 'moment'
import { lower } from 'change-case'
import { connect } from 'react-redux'
import { Button, Modal, Header, Form } from 'semantic-ui-react'
import { compose, lifecycle, withState } from 'recompose'
import { reduxForm, getFormValues, Field } from 'redux-form'
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@material-ui/core'
import { getCategory, getSubCategory } from '../../../helper'
import { FieldRow, FieldSection } from './styled'
import { scrollToFirstValidateFailElement } from 'core/utilities'
import FieldInput, { InputType as type } from 'components/SemanticForm'
import { getMappingOderGlAccounts } from 'ducks/mappingData'
import { showPrItemModal, getMaterialDetail } from 'ducks/purchaseRequisition'
import {
  getUnits, getCurrencies, getGlAccounts, getMaterialGroups,
  getMaterials, getProfitCenters
} from 'ducks/options'
import {
  mappingBudgetTypeAndGL, generateBudgetTypeOption,
  generateAccountAssignmentOption, filterWbs
} from './helper'
import r from 'reactotron-react-js'

var prItemFields = {}

const PrItemModal = (props) => {
  const {
    change, showPrItemModal, isNew, onSubmitItem, valueForm, handleSubmit, subCategory,
    glAccountMapping, unitOptions, unitLoading, currencyOptions, currencyLoading, budgetTypeOptions,
    accountAssignments, materialGroupOptions, plantOptions,
    storageLocationOptions, assetOptions, wbsOptions, glAccountOptions, companyCode,
    costCenterOptions, orderOptions,
    validatingBudget,
    companyPlantMapping, plantStorageLocationMapping,
    materialOptions, materialLoading, getMaterialDetail,
    profitCenterOptions, profitCenterLoading, mappingOrderGlAccounts, mappingWbsAssets, prItemFieldsMapping,
    purchGroupOptionData, mappingPurchasingGroups } = props

  const accAssign = valueForm.accountAssignment ? valueForm.accountAssignment : ''

  const [budgetError, setBudgetError] = React.useState(false)
  const [errorMessage, setErrorMessage] = React.useState(null)

  React.useEffect(() => {
    prItemFields = prItemFieldsMapping
  }, [prItemFieldsMapping])

  const calculateTotal = (change, value1) => value2 => {
    if (value1 !== undefined && value2 !== undefined) {
      change('totalAmount', value1 * value2)
    } else {
      change('totalAmount', 0)
    }
  }

  const renderInputField = (props) => {
    const { input, accAssign, type, editable } = props
    const itemAttr = prItemFieldsMapping[input.name]

    if (props.hide) {
      return null
    }

    if (type === 'empty') {
      return (<FieldInput {...props} />)
    } else {
      if (itemAttr) {
        const attr = itemAttr[lower(accAssign) || '']
        if (attr) {
          const require = input.name === 'productHierarchyLv2' ? false : attr.require
          if (editable !== undefined) {
            return (<FieldInput {...props} require={require} editable={editable} />)
          } else {
            if (attr.display === 'hide') return null
            else return (<FieldInput {...props} require={require} editable={attr.display === 'edit'} />)
          }
        } else {
          return null
        }
      } else {
        return null
      }
    }
  }

  const submitItem = () => {
    // Ignore Validate Budget by Item
    showPrItemModal(false)
    onSubmitItem(valueForm)
  }

  const checkLevelBudget = (current, list, result = []) => {
    if (!current) {
      return result
    }

    var next = {}
    if (result.length === 0) {
      result.push(current)
      next = list.find(b => b.wbsElementNo === current.wbsControlBudget)
      return checkLevelBudget(next, list, result)
    } else if (result.length === 1) {
      if (current.wbsControlBudget === '') { //End of line
        result.push(current)
        return result
      }

      if (current.plan !== 0) {
        result.push(current)
        next = list.find(b => b.wbsElementNo === current.wbsControlBudget)
        return checkLevelBudget(next, list, result)
      } else {
        next = list.find(b => b.wbsElementNo === current.wbsControlBudget)
        return checkLevelBudget(next, list, result)
      }
    } else if (result.length === 2) {
      if (current.wbsControlBudget === '') { //End of line
        result.push(current)
        return result
      } else {
        next = list.find(b => b.wbsElementNo === current.wbsControlBudget)
        return checkLevelBudget(next, list, result)
      }
    } else {
      return result
    }
  }

  const onSelectOrder = (value) => {
    if (value) {
      var order = orderOptions.find(o => o.value === value)
      if (order) {
        change('orderType', order.orderTypeCode)
        change('controllingArea', order.controllingAreaCode)
        change('profitCenter', order.profitCenterCode)
      } else {
        change('orderType', '')
        change('controllingArea', '')
        change('profitCenter', '')
      }

      if (subCategory.isBuddharaksaFoundation) {
        let mapping = mappingOrderGlAccounts.find(o => o.orderNo.removeLeadingZero() === value.removeLeadingZero())
        if (mapping) {
          change('glAccountCode', mapping.glAccount)
        } else {
          change('glAccountCode', '')
        }
      }
    }
  }

  const onSelectBudgetType = (value) => {
    if (glAccountMapping && value) {
      const listGl = glAccountMapping.filter(gl => gl.budgetTypeCode === value)

      if (listGl) {
        if (listGl.length === 1) {
          const gl = listGl[0]
          change('glAccountCode', gl.glAccount || '')
          change('accountAssignment', gl.accountAssignment || '')
        } else {
          const uniqueAccountAssignment = []
          listGl.forEach(gl => {
            if (uniqueAccountAssignment.indexOf(gl.accountAssignment) === -1) {
              uniqueAccountAssignment.push(gl.accountAssignment)
            }
          })

          if (uniqueAccountAssignment.length === 1) {
            change('accountAssignment', uniqueAccountAssignment[0])

            const glByAccountAssignment = listGl.filter(gl => gl.accountAssignment === uniqueAccountAssignment[0])
            if (glByAccountAssignment) {
              if (glByAccountAssignment.length === 1) {
                change('glAccountCode', glByAccountAssignment[0].glAccount || '')
              } else {
                const glByCompany = glByAccountAssignment.find(gl => gl.companyCode === companyCode)
                if (glByCompany) {
                  change('glAccountCode', glByCompany.glAccount || '')

                  if (valueForm.costCenter) {
                    if (glByCompany.ignoreByCostCenters.find(c => {
                      if (c.includes('*')) {
                        return valueForm.costCenter.include(c.replace('*', ''))
                      }

                      if (c.includes('-')) {
                        const listCostCenter = c.split('-') || []
                        if (listCostCenter.length > 1) {
                          let c1 = Number.parseInt(listCostCenter[0])
                          let c2 = Number.parseInt(listCostCenter[0])
                          let cc = Number.parseInt(valueForm.costCenter)
                          if (c1 && c2 && cc) {
                            return (cc >= c1 && cc <= c2)
                          }
                        }
                      }

                      return c === valueForm.costCenter
                    })) {
                      change('glAccountCode', glByCompany.glAccountForIgnore || '')
                    }
                  }
                } else {
                  const gl = glByAccountAssignment.find(gl => gl.companyCode === 'ALL')
                  change('glAccountCode', gl ? gl.glAccount ? gl.glAccount : '' : '')
                }
              }
            }
          }
        }
      }
    }
  }

  const onSelectAccountAssignment = (value) => {
    if (glAccountMapping && valueForm.budgetType && value) {
      const listGl = glAccountMapping.filter(gl => gl.budgetTypeCode === valueForm.budgetType && gl.accountAssignment === value)

      if (listGl) {
        if (listGl.length === 1) {
          const gl = listGl[0]
          change('glAccountCode', gl.glAccount || '')
        } else {
          const uniqueAccountAssignment = []
          listGl.forEach(gl => {
            if (uniqueAccountAssignment.indexOf(gl.accountAssignment) === -1) {
              uniqueAccountAssignment.push(gl.accountAssignment)
            }
          })

          if (uniqueAccountAssignment.length === 1) {
            const glByAccountAssignment = listGl.filter(gl => gl.accountAssignment === uniqueAccountAssignment[0])
            if (glByAccountAssignment) {
              if (glByAccountAssignment.length === 1) {
                change('glAccountCode', glByAccountAssignment[0].glAccount || '')
              } else {
                const glByCompany = glByAccountAssignment.find(gl => gl.companyCode === companyCode)
                if (glByCompany) {
                  change('glAccountCode', glByCompany.glAccount || '')

                  if (valueForm.costCenter) {
                    if (glByCompany.ignoreByCostCenters.find(c => {
                      if (c.includes('*')) {
                        return valueForm.costCenter.include(c.replace('*', ''))
                      }

                      if (c.includes('-')) {
                        const listCostCenter = c.split('-') || []
                        if (listCostCenter.length > 1) {
                          let c1 = Number.parseInt(listCostCenter[0])
                          let c2 = Number.parseInt(listCostCenter[0])
                          let cc = Number.parseInt(valueForm.costCenter)
                          if (c1 && c2 && cc) {
                            return (cc >= c1 && cc <= c2)
                          }
                        }
                      }

                      return c === valueForm.costCenter
                    })) {
                      change('glAccountCode', glByCompany.glAccountForIgnore || '')
                    }
                  }
                } else {
                  const gl = glByAccountAssignment.find(gl => gl.companyCode === 'ALL')
                  change('glAccountCode', gl ? gl.glAccount ? gl.glAccount : '' : '')
                }
              }
            }
          }
        }
      }
    }
  }

  const onSelectCostCenter = (value) => {
    if (valueForm.budgetType && valueForm.accountAssignment) {
      const listGl = glAccountMapping.filter(gl => gl.budgetTypeCode === valueForm.budgetType && gl.accountAssignment === valueForm.accountAssignment)
      if (listGl.length > 1) { //multi condition for gl
        const glByCompany = listGl.find(gl => gl.companyCode === companyCode)
        if (glByCompany) {
          change('glAccountCode', glByCompany.glAccount || '')

          if (value) {
            if (glByCompany.ignoreByCostCenters.find(c => {
              if (c.includes('*')) {
                return valueForm.costCenter.include(c.replace('*', ''))
              }

              if (c.includes('-')) {
                const listCostCenter = c.split('-') || []
                if (listCostCenter.length > 1) {
                  let c1 = Number.parseInt(listCostCenter[0])
                  let c2 = Number.parseInt(listCostCenter[0])
                  let cc = Number.parseInt(value)
                  if (c1 && c2 && cc) {
                    return (cc >= c1 && cc <= c2)
                  }
                }
              }

              return c === value
            })) {
              change('glAccountCode', glByCompany.glAccountForIgnore || '')
            }
          }
        } else {
          const gl = listGl.find(gl => gl.companyCode === 'ALL')
          change('glAccountCode', gl ? gl.glAccount ? gl.glAccount : '' : '')
        }
      }
    }
  }

  const filterAccAssignOptions = () => {
    return generateAccountAssignmentOption(accountAssignments, valueForm.budgetType, glAccountMapping)
  }

  const filterPlantOptions = () => {
    const plantByCompany = companyPlantMapping.filter(cp => cp.companyCode === companyCode) || []
    if (plantByCompany) {
      return plantOptions.filter(p => plantByCompany.find(b => b.plantCode === p.value) !== undefined)
    } else {
      return plantOptions
    }
  }

  const filterStorageLocationOptions = () => {
    const { plant } = valueForm
    const storageLocationByPlant = plantStorageLocationMapping.filter(s => s.plantCode === plant)
    if (storageLocationByPlant) {
      return storageLocationOptions.filter(s => storageLocationByPlant.find(b => b.storageLocationCode === s.value) !== undefined && s.plantCode === plant)
    } else {
      return storageLocationOptions
    }
  }

  const onSelectPlant = (value) => {
    const storageLocationByPlant = plantStorageLocationMapping.filter(s => s.plantCode === value) || []
    var defaultStorageLocation = ''
    if (storageLocationByPlant.length === 1) {
      defaultStorageLocation = storageLocationByPlant[0].storageLocationCode
    } else {
      const defaultStorageLocationData = storageLocationByPlant.find(s => s.isDefault)
      defaultStorageLocation = defaultStorageLocationData ? defaultStorageLocationData.storageLocationCode : ''
    }
    change('storageLocation', defaultStorageLocation)

    // setPurchasingGroupOptions 
    purchGroupOptions.current = getPurchasingGroupOptions(value)
  }

  const getPurchasingGroupOptions = (plant) => {
    if(!plant) plant = props.prItem.plant
    let defaultPurchasingGroup = ''
    let purchasingGroupOptions = []
    let purchasingGroupByCompany = mappingPurchasingGroups.find(m => m.companyCode === companyCode)
    if (subCategory.purchasingGroup) {
      if (subCategory.purchasingGroup[plant]) {
        if (subCategory.purchasingGroup[plant].length === 1) {
          defaultPurchasingGroup = subCategory.purchasingGroup[plant][0]
          let purchGroup = purchGroupOptionData.find(o => o.value === defaultPurchasingGroup)
          if (purchGroup) {
            purchasingGroupOptions.push(purchGroup)
          }
        } else {
          if (purchasingGroupByCompany) {
            subCategory.purchasingGroup[plant].forEach(p => {
              let match = purchasingGroupByCompany.purchasingGroups.find(pg => pg === p)
              if (match) {
                let purchGroup = purchGroupOptionData.find(o => o.value === match)
                if (purchGroup) {
                  purchasingGroupOptions.push(purchGroup)
                }
              }
            })
          }
        }
      } else if (subCategory.purchasingGroup[companyCode]) {
        if (subCategory.purchasingGroup[companyCode].length === 1) {
          defaultPurchasingGroup = subCategory.purchasingGroup[companyCode][0]
          let purchGroup = purchGroupOptionData.find(o => o.value === defaultPurchasingGroup)
          if (purchGroup) {
            purchasingGroupOptions.push(purchGroup)
          }
        } else {
          if (purchasingGroupByCompany) {
            subCategory.purchasingGroup[companyCode].forEach(p => {
              let match = purchasingGroupByCompany.purchasingGroups.find(pg => pg === p)
              if (match) {
                let purchGroup = purchGroupOptionData.find(o => o.value === match)
                if (purchGroup) {
                  purchasingGroupOptions.push(purchGroup)
                }
              }
            })
          }
        }
      } else {
        if (subCategory.purchasingGroup.all) {
          if (subCategory.purchasingGroup.all.length === 1) {
            defaultPurchasingGroup = subCategory.purchasingGroup.all[0]
            let purchGroup = purchGroupOptionData.find(o => o.value === defaultPurchasingGroup)
            if (purchGroup) {
              purchasingGroupOptions.push(purchGroup)
            }
          } else {
            if (purchasingGroupByCompany) {
              subCategory.purchasingGroup.all.forEach(p => {
                let match = purchasingGroupByCompany.purchasingGroups.find(pg => pg === p)
                if (match) {
                  defaultPurchasingGroup = match
                  let purchGroup = purchGroupOptionData.find(o => o.value === match)
                  if (purchGroup) {
                    purchasingGroupOptions.push(purchGroup)
                  }
                }
              })
            }
          }
        }
      }
      if(purchasingGroupOptions.length>0){
        if(defaultPurchasingGroup) change('purchasingGroup',defaultPurchasingGroup)
        return purchasingGroupOptions
      }
    }
    return []
  }

  const purchGroupOptions = React.useRef(getPurchasingGroupOptions(valueForm.plant))

  React.useEffect(() => {
    purchGroupOptions.current = getPurchasingGroupOptions(valueForm.plant);
  }, [valueForm.plant]);

  const onSelectMaterial = (value) => {
    getMaterialDetail(value, onGetMaterialDetailSuccess)
  }

  const onGetMaterialDetailSuccess = (data) => {
    change('itemName', data.materialDescriptionEn)
    change('unit', data.baseUnitMeasure)
    change('materialGroup', data.materialGroup)
  }

  const filterMaterialOptions = (plant) => {
    if (plant) {
      if (materialOptions[plant]) {
        return materialOptions[plant]
      }
    } else {
      let plantOpt = filterPlantOptions()
      let matOptResult = []
      plantOpt.forEach(p => {
        if (materialOptions[p.value]) {
          matOptResult.push(materialOptions[p.value])
        }
      })
      return matOptResult
    }
  }

  const checkHideBudgetTypeOption = (budgetTypeOptions) => {
    return (budgetTypeOptions.length === 1) &&
      (budgetTypeOptions[0].value === 'BT11' || budgetTypeOptions[0].value === 'BT12')
  }

  const onSelectAsset = (value) => {
    if (subCategory.assetType && mappingWbsAssets.length > 0) {
      let mapping = mappingWbsAssets.find(m => m.assetCode === value && m.assetType === subCategory.assetType)
      if (mapping) {
        change('wbsElement', mapping.wbsElementCode)
      } else {
        change('wbsElement', '')
      }
    }
  }

  function checkEnableChangeCurrency() {
    let itemDeleted = props.items.filter(x => x.deleted)
    let itemNotDeleted = props.items.filter(x => !x.deleted)
    return (props.items.length > 0 && itemDeleted.length === props.items.length ? undefined :
      props.items.length > 0 && itemDeleted.length !== props.items.length && itemNotDeleted.length === 1 && isNew ? false :
        props.items.length > 0 && itemDeleted.length !== props.items.length && itemNotDeleted.length === 1 && !isNew ? undefined :
          props.items.length > 0 && itemDeleted.length !== props.items.length && itemNotDeleted.length > 1 ? false :
            props.items.length > 0 && isNew ? false :
              props.items.length === 1 && !isNew ? undefined :
                props.items.length > 1 && !isNew ? false : undefined)
  }

  function checkEnableChangePlant() {
    let itemDeleted = props.items.filter(x => x.deleted)
    let itemNotDeleted = props.items.filter(x => !x.deleted)
    return (props.items.length > 0 && itemDeleted.length === props.items.length ? undefined :
      props.items.length > 0 && itemDeleted.length !== props.items.length && itemNotDeleted.length === 1 && isNew ? false :
        props.items.length > 0 && itemDeleted.length !== props.items.length && itemNotDeleted.length === 1 && !isNew ? undefined :
          props.items.length > 0 && itemDeleted.length !== props.items.length && itemNotDeleted.length > 1 ? false :
            props.items.length > 0 && isNew ? false :
              props.items.length === 1 && !isNew ? undefined :
                props.items.length > 1 && !isNew ? false : undefined)
  }

  React.useEffect(() => {
    if(valueForm.plant){
      var purchasingOrg = ''
      if (subCategory.purchasingOrg) {
        if (subCategory.purchasingOrg[valueForm.plant]) {
          purchasingOrg = subCategory.purchasingOrg[valueForm.plant]
        } else if (subCategory.purchasingOrg[companyCode]) {
          purchasingOrg = subCategory.purchasingOrg[companyCode]
        } else {
          if (subCategory.purchasingOrg.all) {
            purchasingOrg = subCategory.purchasingOrg.all
          }
        }
        change('purchasingOrg',purchasingOrg)
      }
    }
  }, [valueForm.plant])

  return (
    <div>
      <Modal size='large' open={true} maxWidth='lg' fullWidth style={{ zIndex: 900 }} >
        <Header>{isNew ? 'Add Item' : 'Edit Item'}</Header>
        <Modal.Content>
          <Form>
            <FieldSection>
              <span className='title'>Item information</span>
              {
                (subCategory.isTreadingGoods) ?
                  <FieldRow>
                    <Field
                      name='materialNo'
                      label='Material No'
                      require
                      editable
                      loading={materialLoading}
                      options={filterMaterialOptions(valueForm.plant || '')}
                      specialOnChange={onSelectMaterial}
                      type={type.select}
                      component={FieldInput}
                    />
                  </FieldRow> : null
              }
              <FieldRow>
                {
                  (subCategory.isTreadingGoods) ?
                    null :
                    <Field
                      name='itemName'
                      label='Item Name'
                      accAssign={accAssign}
                      type={type.text}
                      component={FieldInput} />
                }
              </FieldRow>
              <FieldRow>
                <Field name='itemDescription' accAssign={accAssign} label='Item Description' type={type.textArea} component={FieldInput} />
              </FieldRow>
              <FieldRow>
                <Field
                  name='quantity'
                  label='Quantity'
                  decimalScale={3}
                  type={type.number}
                  specialOnChange={calculateTotal(change, valueForm.unitPrice)}
                  component={FieldInput} />
                <Field name='unit' accAssign={accAssign} label='Unit' loading={unitLoading} options={unitOptions} type={type.select} component={FieldInput} />
              </FieldRow>
              <FieldRow>
                <Field
                  name='unitPrice'
                  label='Price'
                  type={type.number}
                  specialOnChange={calculateTotal(change, valueForm.quantity)}
                  component={FieldInput} />
                <Field
                  name='currency'
                  accAssign={accAssign}
                  label='Currency'
                  loading={currencyLoading}
                  options={currencyOptions}
                  type={type.select}
                  editable={checkEnableChangeCurrency()}
                  component={FieldInput} />
              </FieldRow>
              <FieldRow>
                <Field name='totalAmount' className='halfRow' accAssign={accAssign} label='Total' type={type.number} component={FieldInput} />
              </FieldRow>
            </FieldSection>
            <FieldSection>
              {
                (!subCategory.isTreadingGoods) ?
                  <React.Fragment>
                    <span className='title'>Budget</span>
                    <FieldRow>
                      <Field
                        name='budgetType'
                        label='Budget Type'
                        className='halfRow'
                        accAssign={accAssign}
                        ignoreClearValue
                        options={budgetTypeOptions}
                        hide={checkHideBudgetTypeOption(budgetTypeOptions)}
                        type={type.select}
                        specialOnChange={onSelectBudgetType}
                        component={renderInputField} />
                      <Field
                        name='accountAssignment'
                        label='Account Assignment'
                        className='halfRow'
                        accAssign={accAssign}
                        ignoreClearValue
                        options={filterAccAssignOptions()}
                        type={type.select}
                        specialOnChange={onSelectAccountAssignment}
                        component={renderInputField} />
                    </FieldRow>
                  </React.Fragment>
                  : null
              }
              <FieldRow>
                <Field name='costCenter' className='halfRow' accAssign={accAssign} label='Cost Center' options={costCenterOptions} type={type.select} specialOnChange={onSelectCostCenter} component={renderInputField} />
                <Field name='glAccountCode' className='halfRow' accAssign={accAssign} label='GL account' options={glAccountOptions} type={type.select} component={renderInputField} />
                <Field name='asset' className='halfRow' accAssign={accAssign} label='Asset' options={assetOptions} specialOnChange={onSelectAsset} type={type.select} component={renderInputField} />
                <Field name='orderNo' className='halfRow' accAssign={accAssign} label='Order No' options={orderOptions} type={type.select} specialOnChange={onSelectOrder} component={renderInputField} />
                <Field name='orderType' className='halfRow' accAssign={accAssign} label='Order type' type={type.text} component={renderInputField} />
                <Field name='wbsElement' className='halfRow' accAssign={accAssign} label='WBS element' options={wbsOptions} type={type.select} component={renderInputField} />
                <Field name='controllingArea' className='halfRow' accAssign={accAssign} label='Controlling Area' type={type.text} component={renderInputField} />
                <Field name='profitCenter' className='halfRow' accAssign={accAssign} label='Profit Center' options={profitCenterOptions} loading={profitCenterLoading} type={type.select} component={renderInputField} />
                <Field name='salesOrder' className='halfRow' accAssign={accAssign} label='Sales Order' type={type.text} component={renderInputField} />
                <Field name='salesOrderItemNo' className='halfRow' accAssign={accAssign} label='Sales Order Item No' type={type.text} component={renderInputField} />
                <Field name='network' className='halfRow' accAssign={accAssign} label='Network' type={type.text} component={renderInputField} />
                <Field name='productHierarchyLv2' className='halfRow' accAssign={accAssign} label='Product Hierarchy Level 2' type={type.text} component={renderInputField} />
                <Field name='customer' className='halfRow' accAssign={accAssign} label='Customer' type={type.text} component={renderInputField} />
              </FieldRow>
            </FieldSection>
            <FieldSection>
              <span className='title'>Delivery Information</span>
              <FieldRow>
                <Field name='startDate' accAssign={accAssign} label='Start Date' type={type.date} component={renderInputField} />
                <Field name='deliveryDate' accAssign={accAssign} label='Delivery Date / Finish Date' type={type.date} component={renderInputField} />
              </FieldRow>
              <FieldRow>
                <Field 
                  name='plant' 
                  accAssign={accAssign} 
                  label='Plant' 
                  options={filterPlantOptions()} 
                  specialOnChange={onSelectPlant} 
                  type={type.select} 
                  component={renderInputField} 
                  editable={checkEnableChangePlant()}/>
                <Field name='storageLocation' accAssign={accAssign} label='Storage Location' options={filterStorageLocationOptions()} type={type.select} component={renderInputField} />
              </FieldRow>
            </FieldSection>
            <FieldSection>
              <span className='title'>Procurement Information</span>
              <FieldRow>
                <Field name='materialGroup' accAssign={accAssign} label='Material Group' options={materialGroupOptions} type={type.select} component={renderInputField} />
                <Field name='purchasingGroup' accAssign={accAssign} label='Purchasing Group' options={purchGroupOptions.current} type={type.select} component={renderInputField} />
              </FieldRow>
            </FieldSection>
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <form onSubmit={handleSubmit(values => submitItem())}>
            <Button
              color='blue'
              // loading={validatingBudget}
              content={isNew ? 'Add' : 'Save'}
              type='submit'
            />
            <Button
              color='red'
              content='Cancel'
              // disabled={validatingBudget}
              onClick={() => showPrItemModal(false)}
            />
          </form>
        </Modal.Actions>
      </Modal>
      <Modal open={budgetError} basic size='tiny' style={{ zIndex: 10000 }}>
        <Header color='red' icon='exclamation circle' content='Budget not available!' />
        <Modal.Content>
          <div style={{ display: 'flex', flex: 1, paddingLeft: '20px' }}>{errorMessage}</div>
        </Modal.Content>
        <Modal.Actions>
          <Button basic inverted color='red'
            content='Close' icon='remove' labelPosition='left'
            onClick={() => {
              setErrorMessage('')
              setBudgetError(false)
            }} />
        </Modal.Actions>
      </Modal>
    </div>
  )
}

const mapStateToProps = (state) => {
  const valueForm = getFormValues('formEditPR')(state) || {}
  var itemValueForm = getFormValues('formEditPrItem')(state) || {}
  const menus = state.pr.menus || []
  var category = {}
  var subCategory = {}
  const prItem = state.pr.prItem || {}

  if (valueForm.menuCategory) {
    category = getCategory(menus)(valueForm.menuCategory)
  }

  if (valueForm.menuSubCategory && category.subCategories) {
    subCategory = getSubCategory(category.subCategories)(valueForm.menuSubCategory)
  }

  const glAccounts = state.pr.glAccounts
  const budgetTypeOptions = generateBudgetTypeOption(state.options.budgetTypes.data, subCategory.budgetTypes)

  // Budget Type
  itemValueForm = mappingBudgetTypeAndGL({
    itemValueForm,
    glAccounts,
    budgetTypeOptions,
    companyCode: valueForm.companyCode || '',
    costCenter: valueForm.costCenterByRequester || '',
    currentGl: prItem.glAccountCode,
  })

  var companyCode = valueForm.companyCode || ''

  const costCenter = itemValueForm.costCenter || state.pr.prItem.costCenter || ''
  const assetOptions = state.options.assets.data.filter(a => a.companyCode === companyCode)
  const assetByCostCenter = assetOptions.find(a => a.costCenterCode === costCenter)
  let defaultAsset = assetByCostCenter ? assetByCostCenter.value : ''

  var defaultPurchasingOrg = ''
  if (subCategory.purchasingOrg) {
    if (subCategory.purchasingOrg[companyCode]) {
      defaultPurchasingOrg = subCategory.purchasingOrg[companyCode]
    } else {
      if (subCategory.purchasingOrg.all) {
        defaultPurchasingOrg = subCategory.purchasingOrg.all
      }
    }
  }

  const wbsOptions = filterWbs({
    itemValueForm,
    glAccounts,
    budgetTypeOptions,
    wbsElements: state.options.wbsElements.data,
  })

  const costCenterOptions = state.options.costCenters.data.filter(c => c.companyCode === companyCode)
  const currentCostCenter = state.options.costCenters.data.find(c => c.value === costCenter)

  if (currentCostCenter && itemValueForm.controllingArea !== currentCostCenter.controllingAreaCode) {
    itemValueForm.controllingArea = currentCostCenter.controllingAreaCode
  }

  const plantByCompany = state.mappingData.companyPlants.data.filter(cp => cp.companyCode === companyCode) || []
  var defaultPlant = ''
  if (plantByCompany.length === 1) {
    defaultPlant = plantByCompany[0].plantCode
  } else if(valueForm.items.length > 0){
    defaultPlant = valueForm.items?.find(i=>!i.deleted)?.plant || ''
  } else{
    const defaultPlantData = plantByCompany.find(p => p.isDefault)
    defaultPlant = defaultPlantData ? defaultPlantData.plantCode : ''
  }
  
  const storageLocationByPlant = state.mappingData.plantStorageLocations.data.filter(s => s.plantCode === defaultPlant) || []
  var defaultStorageLocation = ''
  if (storageLocationByPlant.length === 1) {
    defaultStorageLocation = storageLocationByPlant[0].storageLocationCode
  } else {
    const defaultStorageLocationData = storageLocationByPlant.find(s => s.isDefault)
    defaultStorageLocation = defaultStorageLocationData ? defaultStorageLocationData.storageLocationCode : ''
  }

  const date = new Date()

  const orderOptions = state.options.orders.data.map(o => ({
    ...o,
    text: o.text.removeLeadingZero(),
  })).filter(o => o.companyCode === companyCode)

  const profitCenterOptions = state.options.profitCenters.data.filter(p => p.companyCode === companyCode)

  const mappingWbsAssets = state.mappingData.wbsAssets.data
  let defaultWbs = ''


  if (subCategory.assetType && mappingWbsAssets.length > 0 && costCenter !== '') {
    let asset = assetOptions.find(a => a.costCenterCode === costCenter)
    if (asset) {
      let mapping = mappingWbsAssets.find(m => m.assetCode === asset.value && m.assetType === subCategory.assetType)
      if (mapping) {
        defaultAsset = mapping.assetCode
        defaultWbs = mapping.wbsElementCode
      }
    }
  }
  const isNew = state.pr.isNewPrItem
  let lineNo = 1
  let sapLineNo = null
  if (isNew) {
    lineNo = valueForm.items.length + 1
  } else {
    lineNo = prItem ? prItem.lineNo : valueForm.items.length + 1
    sapLineNo = prItem ? prItem.sapLineNo : null
  }

  var materialGroup = ''
  if (subCategory.materialGroup) {
    materialGroup = subCategory.materialGroup
  } else {
    if (subCategory.materialGroups[companyCode]) {
      materialGroup = subCategory.materialGroups[companyCode]
    } else if (subCategory.materialGroups['all']) {
      materialGroup = subCategory.materialGroups['all']
    }
  }
  return ({
    initialValues: {
      // ...prItem,
      id: prItem.id || 0,
      lineNo: lineNo,
      sapLineNo: sapLineNo,
      itemName: itemValueForm.itemName || prItem.itemName || '',
      itemDescription: itemValueForm.itemDescription || prItem.itemDescription || '',
      quantity: itemValueForm.quantity || prItem.quantity || 0,
      unit: itemValueForm.unit || prItem.unit || '',
      unitPrice: itemValueForm.unitPrice || prItem.unitPrice || 0,
      totalAmount: itemValueForm.totalAmount || prItem.totalAmount || 0,
      currency: itemValueForm.currency || prItem.currency || 'THB',
      startDate: itemValueForm.startDate || prItem.startDate || new Date(date.getFullYear(), date.getMonth(), date.getDate()),
      deliveryDate: itemValueForm.deliveryDate || prItem.deliveryDate,
      budgetType: itemValueForm.budgetType || prItem.budgetType || '',
      accountAssignment: itemValueForm.accountAssignment || prItem.accountAssignment || '',
      materialGroup: itemValueForm.materialGroup || prItem.materialGroup || materialGroup || '',
      purchasingGroup: itemValueForm.purchasingGroup || prItem.purchasingGroup || '',
      purchasingOrg: itemValueForm.purchasingOrg || prItem.purchasingOrg || defaultPurchasingOrg,
      plant: itemValueForm.plant || prItem.plant || defaultPlant || '',
      storageLocation: itemValueForm.storageLocation || prItem.storageLocation || defaultStorageLocation || '',
      glAccountCode: itemValueForm.glAccountCode || prItem.glAccountCode || '',
      orderNo: itemValueForm.orderNo || prItem.orderNo || '',
      orderType: itemValueForm.orderType || prItem.orderType || '',
      costCenter: itemValueForm.costCenter || prItem.costCenter || '',
      wbsElement: itemValueForm.wbsElement || prItem.wbsElement || defaultWbs,
      asset: itemValueForm.asset || prItem.asset || defaultAsset || '',
      controllingArea: itemValueForm.controllingArea || prItem.controllingArea || '',
      profitCenter: itemValueForm.profitCenter || prItem.profitCenter || '',
      salesOrder: itemValueForm.salesOrder || prItem.salesOrder || '',
      salesOrderItemNo: itemValueForm.salesOrderItemNo || prItem.salesOrderItemNo || '',
      network: itemValueForm.network || prItem.network || '',
      productHierarchyLv2: itemValueForm.productHierarchyLv2 || prItem.productHierarchyLv2 || '',
      customer: itemValueForm.customer || prItem.customer || '',
      menuSubCategory: itemValueForm.menuSubCategory || prItem.menuSubCategory || '',
      materialNo: itemValueForm.materialNo || prItem.materialNo || '',
      createdDate: prItem.createdDate || '',
      purchaseRequisitionId: prItem.purchaseRequisitionId || 0,
      isTreadingGoods: subCategory.isTreadingGoods,
    },
    accountAssignments: state.options.accountAssignments.data,
    assetOptions,
    budgetTypeOptions,
    companyCode: valueForm.companyCode,
    companyPlantMapping: state.mappingData.companyPlants.data,
    costCenterOptions,
    currencyLoading: state.options.currencies.loading,
    currencyOptions: state.options.currencies.data,
    glAccountLoading: state.options.glAccounts.loading,
    glAccountOptions: state.options.glAccounts.data,
    glAccountMapping: state.pr.glAccounts,
    isNew: state.pr.isNewPrItem,
    items: valueForm.items || [],
    mappingOrderGlAccounts: state.mappingData.orderGlAccounts.data,
    mappingWbsAssets,
    materialGroupLoading: state.options.materialGroups.loading,
    materialGroupOptions: state.options.materialGroups.data,
    materialLoading: state.options.materials.loading,
    materialOptions: state.options.materials.data,
    onSubmitItem: state.pr.onSubmitItem,
    orderOptions,
    plantOptions: state.options.plants.data,
    plantStorageLocationMapping: state.mappingData.plantStorageLocations.data,
    prItemFieldsMapping: state.mappingData.prItemFields.data,
    profitCenterLoading: state.options.profitCenters.loading,
    profitCenterOptions,
    profitCenters: state.options.profitCenters.data,
    storageLocationOptions: state.options.storageLocations.data,
    subCategory,
    unitLoading: state.options.units.loading,
    unitOptions: state.options.units.data,
    validatingBudget: state.pr.validatingBudget,
    valueForm: itemValueForm,
    wbsOptions,
    purchGroupOptionData: state.options.purchasingGroups.data,
    mappingPurchasingGroups: state.mappingData.purchasingGroups.data,
    prItem: prItem
  })
}

const mapDispatchToProps = {
  showPrItemModal,
  getUnits,
  getCurrencies,
  getGlAccounts,
  getMaterialGroups,
  getMaterialDetail,
  getMaterials,
  getProfitCenters,
  getMappingOderGlAccounts,
}

const validate = values => {
  const errors = {}
  const accAssign = values.accountAssignment || ''

  Object.keys(prItemFields).forEach(key => {
    if (key === 'productHierarchyLv2') return
    var attr = prItemFields[key][lower(accAssign)]
    if (attr.require) {
      if (!values[key]) {
        errors[key] = 'Required!'
      }
    }
  })

  if (values.quantity && values.quantity <= 0) {
    errors.quantity = 'Required!'
  }

  if (values.unitPrice && values.unitPrice <= 0) {
    errors.unitPrice = 'Required!'
  }

  if (values.itemName && values.itemName.length > 40) {
    errors.itemName = 'Item name must be less than or equal to 40 characters!'
  }

  if (values.startDate && values.deliveryDate) {
    if (moment(values.deliveryDate) < moment(values.startDate)) {
      errors.deliveryDate = 'Delivery date must be greater than or equal Start date!'
    }
  }

  if (values.menuSubCategory === 'G16-1') {
    delete errors.itemName
    delete errors.budgetType
    delete errors.accountAssignment
  }

  return errors
}

const contForm = reduxForm({
  form: 'formEditPrItem',
  enableReinitialize: false,
  validate,
  onSubmitFail: scrollToFirstValidateFailElement
})(PrItemModal)

export default connect(mapStateToProps, mapDispatchToProps)(contForm)